import { purgeLegacyAuthTokens } from './authSession';

const STORAGE_KEY = 'parentSchoolSession';

const resolveSchoolId = (user) => {
  const id = user?.schooleId || user?.schoolId;
  return id && typeof id === 'object' ? id._id : id;
};

/** Metadata only — JWTs live in HttpOnly parent_* cookies on the server. */
export function saveParentSchoolSessionBeforeSwitch(childSchool) {
  if (isViewingChildSchool()) return;

  try {
    const userDetail = JSON.parse(localStorage.getItem('userDetail') || '{}');
    const parentSchoolId = resolveSchoolId(userDetail);

    if (!parentSchoolId) return;
    if (String(parentSchoolId) === String(childSchool._id)) return;

    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        userDetail,
        parentSchoolId: String(parentSchoolId),
        parentSchoolName: userDetail.name || '',
        childSchoolId: childSchool._id,
        childSchoolName: childSchool.schooleName || childSchool.name || '',
      }),
    );
  } catch (e) {
    console.error('Failed to save parent school session', e);
  }
}

export function getParentSchoolSession() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function isViewingChildSchool() {
  const session = getParentSchoolSession();
  if (!session?.parentSchoolId) return false;

  try {
    const current = JSON.parse(localStorage.getItem('userDetail') || '{}');
    const currentId = resolveSchoolId(current);
    return Boolean(currentId && String(currentId) !== String(session.parentSchoolId));
  } catch {
    return false;
  }
}

/**
 * Restore parent school UI metadata after server restores parent cookies.
 * @param {object} [parentUser] response from restore-parent-session
 */
export function restoreParentSchoolSession(parentUser) {
  const session = getParentSchoolSession();
  if (!session?.userDetail && !parentUser) return false;

  if (parentUser) {
    localStorage.setItem(
      'userDetail',
      JSON.stringify({
        ...(session?.userDetail || {}),
        ...parentUser,
      }),
    );
  } else if (session?.userDetail) {
    localStorage.setItem('userDetail', JSON.stringify(session.userDetail));
  } else {
    return false;
  }

  localStorage.removeItem(STORAGE_KEY);
  purgeLegacyAuthTokens();
  return true;
}

export function clearParentSchoolSession() {
  localStorage.removeItem(STORAGE_KEY);
}
